import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AgmCoreModule } from "@agm/core";
import { SlimLoadingBarModule } from "ng2-slim-loading-bar";
import { FullComponent } from "./layouts/full/full.component";
import { BlankComponent } from "./layouts/blank/blank.component";
import { NavigationComponent } from "./shared/header-navigation/navigation.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { BreadcrumbComponent } from "./shared/breadcrumb/breadcrumb.component";
import { Approutes } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SpinnerComponent } from "./shared/spinner.component";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { AuthGuard } from "./auth.guard";
import { SessionService } from "./session.service";
import {
  CommonModule,
  LocationStrategy,
  HashLocationStrategy,
} from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ConfirmDeleteComponent } from "./shared/component/confirm-delete/confirm-delete.component";
import { ToastrModule } from "ngx-toastr";
import { CommonService } from "./views/common/services/common.service";
import { OpUsersService } from "./views/common/services/op-users.service";
import { ConfirmationDialogService } from "./views/common/services/confirmation-dialog.service";
import { DatePipe } from "@angular/common";
import { DropdownDialogComponent } from "./views/AdminPanel/op product Builder/banners and offers/dropdown-dialog/dropdown-dialog.component";
import { PromptDialogComponent } from "./views/common/dialogs/prompt-dialog/prompt-dialog.component";
import { VidioDialogComponent } from "./views/common/dialogs/vidio-dialog/vidio-dialog.component";
import { ConfirmationDialogComponent } from "./views/common/dialogs/confirmation-dialog/confirmation-dialog.component";
import { MountUsbConfirmComponent } from "./views/common/dialogs/mount-usb-confirm/mount-usb-confirm.component";
import { ImageDialogComponent } from "./views/common/dialogs/image-dialog/image-dialog.component";
import { LightBoxDialogComponent } from "./views/common/dialogs/light-box-dialog/light-box-dialog.component";
import { TemplateFieldDialogComponent } from "./views/AdminPanel/op product Builder/Templates/template-field-dialog/template-field-dialog.component";
import { ThreeSixtyModule } from "@mediaman/angular-three-sixty";
import { OpNewsletterDialogComponent } from "./views/AdminPanel/op-news-letters/op-newsletter-dialog/op-newsletter-dialog.component";
import { OpSitesService } from "./views/common/services/op-sites.service";
import { OpManageOrderSiteComponent } from "./op-manage-order-site/op-manage-order-site.component";
import { CartInfoService } from "./views/common/services/cart-info.service";
import { AngularFileUploaderModule } from "angular-file-uploader";
import { OfferBoxComponent } from "./views/common/dialogs/offer-box/offer-box.component";
import { FullScreenProofcardComponent } from "./views/common/dialogs/full-screen-proofcard/full-screen-proofcard.component";
import { OpChildDialogComponent } from "./views/AdminPanel/Orders/op-child-dialog/op-child-dialog.component";
import { CustomSpinnerComponent } from "./shared/custom-spinner.component";
import { LinkProofcardDialogComponent } from "./views/common/dialogs/link-proofcard-dialog/link-proofcard-dialog.component";
import { OpProofcardService } from "./views/common/services/op-proofcard.service";
import { OrderEditDialogComponent } from "./views/common/dialogs/order-edit-dialog/order-edit-dialog.component";
import {
  POSITION,
  NgxUiLoaderConfig,
  SPINNER,
  PB_DIRECTION,
  NgxUiLoaderModule,
  NgxUiLoaderHttpModule,
  NgxUiLoaderService,
} from "ngx-ui-loader";
import { TermsConditionsComponent } from "./views/common/dialogs/terms-conditions/terms-conditions.component";
import { OpContinueShoppingPopUpComponent } from "./views/common/dialogs/op-continue-shopping-pop-up/op-continue-shopping-pop-up.component";
import { LoginOrRegisterDialogComponent } from "./views/common/dialogs/login-or-register-dialog/login-or-register-dialog.component";
import { AuthInterceptor } from "./auth.interceptor";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { CommentBoxComponent } from "./views/common/dialogs/comment-box/comment-box.component";
import { OrderDetailComponent } from "./views/common/dialogs/order-detail/order-detail.component";
import { BrowserSupportComponent } from "./views/common/dialogs/browser-support/browser-support.component";
import { CheckoutOptionsComponent } from "./views/WebPanel/checkout-options/checkout-options.component";
import { StudentNameUpdateComponent } from "./views/common/dialogs/student-name-update/student-name-update.component";
import { OrderEditAddressComponent } from "./views/common/dialogs/order-edit-address/order-edit-address.component";
import { OrderEditShippingAddressComponent } from "./views/common/dialogs/order-edit-shipping-address/order-edit-shipping-address.component";
import { CustomerMessageShowComponent } from "./views/common/dialogs/customer-message-show/customer-message-show.component";
import { DescriptionBoxComponent } from "./views/common/dialogs/description-box/description-box.component";
import { ProofcardImageViewerComponent } from "./views/common/dialogs/proofcard-image-viewer/proofcard-image-viewer.component";
import { PosterCredentialManagerComponent } from "./views/common/dialogs/poster-credential-manager/poster-credential-manager.component";
import { OpJobService } from "./views/common/services/op-job.service";
import { ExportFieldDialogComponent } from "./views/AdminPanel/op product Builder/product export/export-field-dialog/export-field-dialog/export-field-dialog.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CalendarBookingDetailDialogComponent } from "./views/AdminPanel/op-booking-calender/calendar-booking-detail-dialog/calendar-booking-detail-dialog.component";
import { ProofcardDownloadPoupComponent } from "./views/AdminPanel/sites/jobs/proofcard/op-poofcard/proofcard-download-poup/proofcard-download-poup.component";
import { OrderdeadlinedialogComponent } from "./views/AdminPanel/sites/jobs/proofcard/proofcard-uploader/orderdeadlinedialog/orderdeadlinedialog/orderdeadlinedialog.component";
import { AllDeleteDialogComponent } from './views/common/dialogs/all-delete-dialog/all-delete-dialog.component';
import { FtpBulkUploadComponent } from "./views/common/dialogs/ftp-bulk-upload/ftp-bulk-upload.component";
import { OrderImageViewerComponent } from "./views/common/dialogs/order-image-viewer/order-image-viewer.component"
import { OrderviewLoginComponent } from "./views/WebPanel/op-proofcard/op-proofcardOrderviewLogin/op-orderviewLogin.component";
import { OrderDetailDownloadComponent } from "./views/common/dialogs/order-detail-download/order-detail-download.component";
import { MaintenanceComponent } from './views/common/maintenance/maintenance.component';
// import { SelectedImgforMobileComponent } from "./views/WebPanel/My Download/My Images for mobile/selected-img-mobile.component";

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "red",
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 40,
  fgsColor: "#73970e",
  bgsType: SPINNER.squareJellyBox, // background spinner type
  fgsType: SPINNER.squareJellyBox, // foreground spinner type
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 5, // progress bar thickness
  text: "Please wait! We are working on your request!",
};

export const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface =
  {
    suppressScrollX: true,
    wheelSpeed: 1,
    wheelPropagation: true,
    minScrollbarLength: 20,
  };

export const exludeLoaderFromAPI = [
  "https://oliveportraits.co.uk/olive/backend/public/api/ftpZone/imageUpload",
  "https://oliveportraits.co.uk/olive/backend/public/api/ftpZone/edit",
  "https://oliveportraits.co.uk/olive/backend/public/api/ftpZone/sendMail",
  "https://oliveportraits.co.uk/olive/backend/public/api/jobBySite",
  "https://oliveportraits.co.uk/api/ftpZone/imageUpload",
  "https://oliveportraits.co.uk/api/ftpZone/edit",
  "https://oliveportraits.co.uk/olive/backend/public/api/order/itemUpdateStatus",
  "https://oliveportraits.co.uk/olive/backend/public/api/order/isInProgress",
  "https://oliveportraits.co.uk/api/ftpZone/sendMail",
  "https://oliveportraits.co.uk/api/jobBySite",
  "https://oliveportraits.co.uk/api/order/itemUpdateStatus",
  "https://oliveportraits.co.uk/api/order/isInProgress",
];

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    CustomSpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    ConfirmDeleteComponent,
    ConfirmationDialogComponent,
    MountUsbConfirmComponent,
    PromptDialogComponent,
    DropdownDialogComponent,
    ImageDialogComponent,
    VidioDialogComponent,
    LightBoxDialogComponent,
    TemplateFieldDialogComponent,
    OpNewsletterDialogComponent,
    OpManageOrderSiteComponent,
    OfferBoxComponent,
    FullScreenProofcardComponent,
    OpChildDialogComponent,
    LinkProofcardDialogComponent,
    OrderEditDialogComponent,
    TermsConditionsComponent,
    OpContinueShoppingPopUpComponent,
    LoginOrRegisterDialogComponent,
    CommentBoxComponent,
    OrderDetailComponent,
    BrowserSupportComponent,
    CheckoutOptionsComponent,
    StudentNameUpdateComponent,
    OrderEditAddressComponent,
    OrderEditShippingAddressComponent,
    CustomerMessageShowComponent,
    DescriptionBoxComponent,
    ProofcardImageViewerComponent,
    PosterCredentialManagerComponent,
    ExportFieldDialogComponent,
    CalendarBookingDetailDialogComponent,
    ProofcardDownloadPoupComponent,
    OrderdeadlinedialogComponent,
    FtpBulkUploadComponent,
    AllDeleteDialogComponent,
    OrderImageViewerComponent,
    // SelectedImgforMobileComponent,
    OrderviewLoginComponent,
    OrderDetailDownloadComponent,
    MaintenanceComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({ preventDuplicates: true }),
    HttpClientModule,
    NgbModule.forRoot(),
    SlimLoadingBarModule.forRoot(),
    RouterModule.forRoot(Approutes, {
      useHash: false,
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      scrollOffset: [0, 50],
    }),
    PerfectScrollbarModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBUb3jDWJQ28vDJhuQZxkC0NXr_zycm8D0",
    }),
    NgMultiSelectDropDownModule.forRoot(),
    ThreeSixtyModule,
    AngularFileUploaderModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      exclude: exludeLoaderFromAPI,
    }),
    NgxDaterangepickerMd.forRoot(),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    AuthGuard,
    SessionService,
    CommonService,
    OpUsersService,
    ConfirmationDialogService,
    DatePipe,
    OpSitesService,
    CartInfoService,
    OpProofcardService,
    NgxUiLoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    OpJobService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmationDialogComponent,
    MountUsbConfirmComponent,
    PromptDialogComponent,
    DropdownDialogComponent,
    ImageDialogComponent,
    VidioDialogComponent,
    LightBoxDialogComponent,
    TemplateFieldDialogComponent,
    OpNewsletterDialogComponent,
    OfferBoxComponent,
    FullScreenProofcardComponent,
    OpChildDialogComponent,
    LinkProofcardDialogComponent,
    OrderEditDialogComponent,
    TermsConditionsComponent,
    OpContinueShoppingPopUpComponent,
    LoginOrRegisterDialogComponent,
    CommentBoxComponent,
    OrderDetailComponent,
    CheckoutOptionsComponent,
    StudentNameUpdateComponent,
    OrderEditAddressComponent,
    OrderEditShippingAddressComponent,
    CustomerMessageShowComponent,
    DescriptionBoxComponent,
    ProofcardImageViewerComponent,
    PosterCredentialManagerComponent,
    ExportFieldDialogComponent,
    CalendarBookingDetailDialogComponent,
    ProofcardDownloadPoupComponent,
    OrderdeadlinedialogComponent,
    FtpBulkUploadComponent,
    OrderImageViewerComponent,
    // SelectedImgforMobileComponent,
    OrderviewLoginComponent,
    OrderDetailDownloadComponent
  ],
})
export class AppModule {}
